import { createRoot } from "react-dom/client";
import { islands } from "../islands";

const roots = new Map();

function mountIslands() {
  document.querySelectorAll("[data-react-island]").forEach((el) => {
    if (el.dataset.reactMounted === "true") return;

    const name = el.dataset.reactIsland;
    const Component = islands[name];
    if (!Component) {
      console.warn(`No React island registered for "${name}"`);
      return;
    }

    const props = JSON.parse(el.dataset.props || "{}");
    const root = createRoot(el);
    root.render(<Component {...props} />);
    roots.set(el, root);
    el.dataset.reactMounted = "true";
  });
}

function unmountIslandsBeforeCache() {
  document.querySelectorAll("[data-react-island]").forEach((el) => {
    roots.get(el)?.unmount();
    roots.delete(el);
    delete el.dataset.reactMounted;
  });
}

// This entry can be added to the page lazily during a Turbo navigation (Vite is
// loaded only on pages that render an island). In that case DOMContentLoaded and
// turbo:load have already fired, so mount once immediately. mountIslands is
// idempotent (it skips already-mounted nodes), so this is safe to call again.
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", mountIslands, { once: true });
} else {
  mountIslands();
}

// Guard against duplicate listeners if this entry re-executes after being
// re-added to the <head> by a later Turbo navigation.
if (!window.__islandsBootstrapped) {
  window.__islandsBootstrapped = true;
  document.addEventListener("turbo:load", mountIslands);
  document.addEventListener("turbo:before-cache", unmountIslandsBeforeCache);
}
